export default __webpack_public_path__ + "static/media/Logo.78bed3c3.jpeg";